import React, {FC} from 'react';
import styled from 'styled-components';

import {renderLanguageCode} from '../../../../../../../libs/shared/core/src/helpers/ai/composeV2Helpers';
import {DropdownBoxProps} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBox';
import {DropdownBoxCoordinator} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {OverflowWithCount} from '../../../../../common/overflow/overflowWithCount';
import {AiTranslateLanguageDropdown, AiTranslateLanguageDropdownProps} from './aiTranslateLanguageDropdown';
import {renderEmojiForLanguageCode} from './helpers';

/*
 * Props.
 */

export interface AiTranslateLanguageInputProps
  extends Omit<AiTranslateLanguageDropdownProps, 'dropdownProps'> {
  dropdownBoxProps: DropdownBoxProps;
}

/*
 * Styles.
 */

const StyledEmoji = styled.div`
  display: inline-block;
  vertical-align: text-top;
`;

/*
 * Component.
 */

export const AiTranslateLanguageInput: FC<AiTranslateLanguageInputProps> = ({
  selectedLanguages,
  dropdownBoxProps,
  ...languageDropdownProps
}) => (
  <DropdownBoxCoordinator
    {...dropdownBoxProps}
    value={
      <OverflowWithCount
        shouldUseMaximumWidth
        elements={selectedLanguages}
        buildElementKey={(element) => element}
        renderElement={(code) => (
          <>
            <StyledEmoji>{renderEmojiForLanguageCode(code)}</StyledEmoji>
            &nbsp;
            {renderLanguageCode(code)}
          </>
        )}
        renderOverflowIndicator={(extra) => `, +${extra}`}
        renderSeparator={() => ', '}
      />
    }
    renderDropdown={(dropdownProps) => (
      <AiTranslateLanguageDropdown
        dropdownProps={dropdownProps}
        width={dropdownProps.anchorWidth}
        {...languageDropdownProps}
        selectedLanguages={selectedLanguages}
      />
    )}
  />
);
